var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H53C58.5228 0 63 4.47715 63 10V60.5L0.5 0Z",
    fill: "#44799C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6418 9.27724C55.0915 9.67086 55.1219 10.3381 54.7097 10.7675L40.4159 25.658C40.2123 25.87 39.9269 25.9935 39.6257 25.9998C39.3245 26.006 39.0337 25.8945 38.8207 25.6911L32.3235 19.4867C31.8922 19.0748 31.8922 18.407 32.3235 17.9951C32.7548 17.5832 33.4542 17.5832 33.8855 17.9951L39.567 23.4205L53.0813 9.34203C53.4935 8.91263 54.1922 8.88362 54.6418 9.27724Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxactive);
export default __webpack_public_path__ + "static/media/checkboxactive.a0937dae74120949c0fa70af620ec58d.svg";
export { ForwardRef as ReactComponent };